import {Injector} from "@angular/core"
import {Observable} from "rxjs"
import {MeshNodes, DataNodes} from "@cm/render-nodes"
import {hashObject} from "@cm/utils"
import {evaluateGeometry, WebAssemblyWorkerService} from "@app/template-editor/helpers/mesh-processing"
import {BaseGeometryDataCache} from "@app/template-editor/helpers/base-geometry-data-cache"
import {ReifiedGeometryData} from "@cm/template-nodes"

export class GeometryDataCache extends BaseGeometryDataCache<MeshNodes.GeomGraph, ReifiedGeometryData> {
    constructor(injector: Injector) {
        const workerService = injector.get(WebAssemblyWorkerService)
        super((graph, resources) => evaluateGeometry(workerService, graph, resources))
    }

    evaluateGeometry(graph: MeshNodes.GeomGraph, resources: DataNodes.EvaluationResources): Observable<ReifiedGeometryData> {
        return this.cache.get(hashObject(graph), [graph, resources])
    }
}
